var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVvxtnlp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 368,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.819 181.274c0-101.62-82.38-184-184-184s-184 82.38-184 184 82.38 184 184 184 184-82.38 184-184z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 119.6a64.406 64.406 0 0 0-59.497 39.755A64.406 64.406 0 0 0 119.6 184H92c.001-25.405 10.298-48.405 26.947-65.054C135.595 102.297 158.595 92 184 92v27.6m0 64.4c-25.405.001-48.404 10.299-65.052 26.947C102.299 227.596 92.001 250.595 92 276h27.6c0-17.784 7.208-33.884 18.862-45.538C150.116 218.808 166.216 211.6 184 211.6V184m59.498-67.355A64.432 64.432 0 0 0 248.4 92H276a91.957 91.957 0 0 1-7.003 35.207 91.992 91.992 0 0 1-49.791 49.789A91.995 91.995 0 0 1 184 184v-27.6a64.342 64.342 0 0 0 35.778-10.855 64.34 64.34 0 0 0 23.72-28.9",
    fill: "#fff",
    style: {
      stroke: "#000",
      strokeMiterlimit: 1,
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 5
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.323 364.895c50.81 0 92-41.19 92-92s-41.19-92-92-92-92 41.19-92 92 41.19 92 92 92z",
    fill: "#7EE989",
    strokeWidth: 4,
    stroke: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.606 313.115C323.421 334.076 300.085 348 273.5 348c-41.146 0-74.5-33.354-74.5-74.5 0-1.407.039-2.805.115-4.191h27.482v8.03H207.95l.129 1.579c2.756 33.719 30.992 60.224 65.421 60.224 21.373 0 40.361-10.217 52.344-26.027h10.762zm.83-43.806h1.593l-.138-1.588c-2.928-33.547-31.086-59.863-65.391-59.863-22.668 0-42.652 11.492-54.443 28.96h-10.416C221.442 214.235 245.693 199 273.5 199c41.146 0 74.5 33.354 74.5 74.5a74.06 74.06 0 0 1-.098 3.839h-25.353v-8.03h14.887zm-65.096 26.839 1.379 3.743 1.364-3.747 19.116-52.451h11.682l-26.401 66.533h-11.642l-26.497-66.533h11.682l19.317 52.455z",
    fill: "#2E3A59",
    fillOpacity: 0.04,
    strokeWidth: 4,
    stroke: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 54.689,
    y1: 50.6,
    x2: 314.844,
    y2: 310.756,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.18 -2.726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#7EE989"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h368v368H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVvxtnlp);
export default __webpack_public_path__ + "static/media/VVXTNLP.eea88941a2a67df52a439f6df4a1b205.svg";
export { ForwardRef as ReactComponent };